import { ServicePriority } from '../../core/containers/IContainer';
import { IContainer } from '../../core/containers';
import BaseContainer from '../../core/containers/BaseContainer';
import { SetServiceDependencies } from '../startup/types';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export type ContainersType = {
  authRefreshContainer: IContainer;
  accessControlContainer: IContainer;
};

export default class ContainersInitializer {
  public static instantiate(): ContainersType {
    const authRefreshContainer = new BaseContainer();
    const accessControlContainer = new BaseContainer();

    const containers: ContainersType = {
      authRefreshContainer,
      accessControlContainer
    };

    return containers;
  }

  public static async resolveDependencies({
    services,
    containers
  }: SetServiceDependencies): Promise<void> {
    // 1. Setting up dependencies for Auth container
    const authRefreshContainer: IContainer = containers.authRefreshContainer;

    if (services?.consentService) {
      authRefreshContainer.addService(services.consentService);
    }
    if (services?.userService) {
      authRefreshContainer.addService(services.userService);
    }

    // Adding performance marks around login process
    authRefreshContainer.addRefreshServices(
      () => {
        performance.mark('login-started');
      },
      ServicePriority.VITAL,
      'performance'
    );

    authRefreshContainer.addRefreshServices(
      () => {
        performance.mark('login-finished');

        const loginMeasure = performance.measure(
          'login-duration',
          'login-started',
          'login-finished'
        );
        internalLogger?.debug?.(`Login duration: ${loginMeasure.duration} ms`);
      },
      ServicePriority.MESSAGE,
      'performance'
    );

    // 2. Setting up dependencies for Access Control container
    // TODO: For now, the services will added themselves to the container. Because they are still Interfaces instead of services.
  }
}
